import entryFactory from "bpmn-js-properties-panel/lib/factory/EntryFactory";
import cmdHelper from "bpmn-js-properties-panel/lib/helper/CmdHelper";
import elementHelper from "bpmn-js-properties-panel/lib/helper/ElementHelper";
import extensionElementsHelper from "bpmn-js-properties-panel/lib/helper/ExtensionElementsHelper";
import assign from "lodash/assign";
import map from "lodash/map";
import { isSesi } from "../../../../../util/environmentUtils";

const DEFAULT_DELEGATE_PROPS = ["class", "expression", "delegateExpression"];

const DELEGATE_PROPS = {
  "camunda:class": undefined,
  "camunda:expression": undefined,
  "camunda:delegateExpression": undefined,
  "camunda:resultVariable": undefined,
};

const DMN_CAPABLE_PROPS = {
  "camunda:decisionRef": undefined,
  "camunda:decisionRefBinding": "latest",
  "camunda:decisionRefVersion": undefined,
  "camunda:mapDecisionResult": "resultList",
  "camunda:decisionRefTenantId": undefined,
};

const EXTERNAL_CAPABLE_PROPS = {
  "camunda:type": undefined,
  "camunda:topic": undefined,
};

export default function (element, bpmnFactory, options, translate) {
  const DEFAULT_OPTIONS = [
    { value: "class", name: translate("Java Class") },
    { value: "expression", name: translate("Expression") },
    { value: "delegateExpression", name: translate("Delegate Expression") },
  ];

  const DMN_OPTION = [{ value: "dmn", name: translate("DMN") }];

  const EXTERNAL_OPTION = [{ value: "external", name: translate("External") }];

  const CONNECTOR_OPTION = [
    { value: "connector", name: translate("Connector") },
  ];

  const SCRIPT_OPTION = [{ value: "script", name: translate("Script") }];

  // eslint-disable-next-line no-unused-vars
  const BRMS_OPTION = [{ value: "smartrules", name: translate("smartRules") }];

  const GERAR_MINUTA_OPTION = [
    { value: "gerarminuta", name: translate("Gerar minuta") },
  ];

  const REGISTRAR_DOCUMENTO_OPTION = [
    { value: "registrardocumento", name: translate("Registrar documento") },
  ];

  const GERAR_PDF_REGISTRAR = [
    { value: "gerarpdfregistrar", name: translate("Gerar PDF e Registrar") },
  ];

  const REGISTRAR_ARQUIVAR_DOCUMENTO_OPTION = [
    {
      value: "registrararquivardocumento",
      name: translate("Registrar e Arquivar"),
    },
  ];

  const GERAR_PDF_NEW_OPTION = [
    { value: "gerarpdfnew", name: translate("Gerar PDF") },
  ];

  const GERAR_XML_OPTION = [
    { value: "gerarxml", name: translate("Gerar XML") },
  ];

  const INTEGRAR_DOCZ_OPTION = [
    { value: "integrardocz", name: translate("Integrar Docz") },
  ];

  const INTEGRAR_DOCZ_ETIQUETA_OPTION = [
    {
      value: "integrardoczetiqueta",
      name: translate("Integrar Docz Etiqueta"),
    },
  ];

  const INTEGRAR_DOCZ_SESI_OPTION = [
    { value: "integrardoczsesi", name: translate("Integrar Docz (Sesi)") },
  ];

  const INTEGRAR_SEI_OPTION = [
    { value: "integrarsei", name: translate("Integrar SEI") },
  ];

  const INTEGRAR_ASSINATURA_OPTION = [
    { value: "integrarassinatura", name: translate("Integrar Assinatura") },
  ];

  const INTEGRAR_ASSINATURA_LOTE_OPTION = [
    { value: "integrarassinaturalote", name: translate("Enviar documentos para Assinatura") },
  ];

  const INTEGRAR_ASSINATURA_LOTE_GET_RESULT_OPTION = [
    { value: "integrarassinaturalotegetresult", name: translate("Obter documentos Assinados") },
  ];

  const INTEGRAR_API_MANAGER_OPTION = [
    { value: "integrarapimanager", name: translate("Integrar Api Manager") },
  ];

  const GERAR_QR_BAR_CODE_OPTION = [
    { value: "gerarqrbarcode", name: translate("Gerar QR/Bar Code") },
  ];

  const getType = options.getImplementationType,
    getBusinessObject = options.getBusinessObject;

  const hasDmnSupport = options.hasDmnSupport,
    hasExternalSupport = options.hasExternalSupport,
    hasServiceTaskLikeSupport = options.hasServiceTaskLikeSupport,
    hasScriptSupport = options.hasScriptSupport,
    hasBrmsSupport = options.hasBrmsSupport,
    hasRegistrarDocumentoSupport = options.hasRegistrarDocumentoSupport,
    hasGerarMinutaSupport = options.hasGerarMinutaSupport,
    hasGerarPdfRegistrarSupport = options.hasGerarPdfRegistrarSupport,
    hasRegistrarArquivarDocumentoSupport =
      options.hasRegistrarArquivarDocumentoSupport,
    hasGerarPdfNewSupport = options.hasGerarPdfNewSupport,
    hasGerarXmlSupport = options.hasGerarXmlSupport,
    hasIntegrarDoczSupport = options.hasIntegrarDoczSupport,
    hasIntegrarDoczEtiquetaSupport = options.hasIntegrarDoczEtiquetaSupport,
    hasIntegrarDoczSesiSupport = options.hasIntegrarDoczSesiSupport,
    hasIntegrarSeiSupport = options.hasIntegrarSeiSupport,
    hasIntegrarAssinaturaSupport = options.hasIntegrarAssinaturaSupport,
    hasIntegrarAssinaturaLoteSupport = options.hasIntegrarAssinaturaLoteSupport,
    hasIntegrarAssinaturaLoteGetResultSupport = options.hasIntegrarAssinaturaLoteGetResultSupport,
    hasIntegrarApiManagerSupport = options.hasIntegrarApiManagerSupport,
    hasGerarQrBarCodeSupport = options.hasGerarQrBarCodeSupport;

  const entries = [];

  let selectOptions = DEFAULT_OPTIONS.concat([]);

  if (hasDmnSupport) {
    selectOptions = selectOptions.concat(DMN_OPTION);
  }

  if (hasExternalSupport) {
    selectOptions = selectOptions.concat(EXTERNAL_OPTION);
  }

  if (hasServiceTaskLikeSupport) {
    selectOptions = selectOptions.concat(CONNECTOR_OPTION);
  }

  if (hasScriptSupport) {
    selectOptions = selectOptions.concat(SCRIPT_OPTION);
  }
  // if (hasBrmsSupport) {
  //   selectOptions = selectOptions.concat(BRMS_OPTION);
  // }
  if (hasGerarMinutaSupport) {
    selectOptions = selectOptions.concat(GERAR_MINUTA_OPTION);
  }

  if (hasGerarPdfRegistrarSupport) {
    selectOptions = selectOptions.concat(GERAR_PDF_REGISTRAR);
  }

  if (hasRegistrarDocumentoSupport) {
    selectOptions = selectOptions.concat(REGISTRAR_DOCUMENTO_OPTION);
  }

  if (hasRegistrarArquivarDocumentoSupport) {
    selectOptions = selectOptions.concat(REGISTRAR_ARQUIVAR_DOCUMENTO_OPTION);
  }

  if (hasGerarPdfNewSupport) {
    selectOptions = selectOptions.concat(GERAR_PDF_NEW_OPTION);
  }

  if (hasGerarXmlSupport) {
    selectOptions = selectOptions.concat(GERAR_XML_OPTION);
  }

  if (hasIntegrarDoczSupport) {
    selectOptions = selectOptions.concat(INTEGRAR_DOCZ_OPTION);
  }

  if (hasIntegrarDoczEtiquetaSupport) {
    selectOptions = selectOptions.concat(INTEGRAR_DOCZ_ETIQUETA_OPTION);
  }

  if (hasIntegrarDoczSesiSupport && isSesi()) {
    selectOptions = selectOptions.concat(INTEGRAR_DOCZ_SESI_OPTION);
  }

  if (hasIntegrarSeiSupport) {
    selectOptions = selectOptions.concat(INTEGRAR_SEI_OPTION);
  }

  if (hasIntegrarAssinaturaSupport) {
    selectOptions = selectOptions.concat(INTEGRAR_ASSINATURA_OPTION);
  }

  if (hasIntegrarAssinaturaLoteSupport) {
    selectOptions = selectOptions.concat(INTEGRAR_ASSINATURA_LOTE_OPTION);
  }
  
  if (hasIntegrarAssinaturaLoteGetResultSupport) {
    selectOptions = selectOptions.concat(INTEGRAR_ASSINATURA_LOTE_GET_RESULT_OPTION);
  }

  if (hasIntegrarApiManagerSupport) {
    selectOptions = selectOptions.concat(INTEGRAR_API_MANAGER_OPTION);
  }

  if (hasGerarQrBarCodeSupport){
    selectOptions = selectOptions.concat(GERAR_QR_BAR_CODE_OPTION)
  }

  selectOptions.push({ value: "" });

  entries.push(
    entryFactory.selectBox(translate, {
      id: "implementation",
      label: translate("Implementation"),
      selectOptions,
      modelProperty: "implType",

      get(element, node) {
        return {
          implType: getType(element) || "",
        };
      },

      set(element, values, node) {
        const bo = getBusinessObject(element);
        const oldType = getType(element);
        const newType = values.implType;

        let props = assign({}, DELEGATE_PROPS);

        if (DEFAULT_DELEGATE_PROPS.indexOf(newType) !== -1) {
          let newValue = "";
          if (DEFAULT_DELEGATE_PROPS.indexOf(oldType) !== -1) {
            newValue = bo.get("camunda:" + oldType);
          }
          props["camunda:" + newType] = newValue;
        }
        if (oldType === "smartrules") {
          bo.set("camunda:smartrules", "");
        }

        if (oldType === "registrardocumento") {
          bo.set("camunda:registrardocumento", "");
        }

        if (oldType === "gerarminuta") {
          bo.set("camunda:gerarminuta", "");
        }

        if (oldType === "gerarpdfregistrar") {
          bo.set("camunda:gerarpdfregistrar", "");
        }

        if (oldType === "registrararquivardocumento") {
          bo.set("camunda:registrararquivardocumento", "");
        }

        if (oldType === "gerarpdfnew") {
          bo.set("camunda:gerarpdfnew", "");
        }

        if (oldType === "gerarxml") {
          bo.set("camunda:gerarxml", "");
        }

        if (oldType === "integrardocz") {
          bo.set("camunda:integrardocz", "");
        }

        if (oldType === "integrardoczetiqueta") {
          bo.set("camunda:integrardoczetiqueta", "");
        }

        if (oldType === "integrardoczsesi") {
          bo.set("camunda:integrardoczsesi", "");
        }

        if (oldType === "integrarsei") {
          bo.set("camunda:integrarsei", "");
        }

        if (oldType === "integrarassinatura") {
          bo.set("camunda:integrarassinatura", "");
        }

        if (oldType === "integrarassinaturalote") {
          bo.set("camunda:integrarassinaturalote", "");
        }

        if (oldType === "integrarassinaturalotegetresult") {
          bo.set("camunda:integrarassinaturalotegetresult", "");
        }

        if (oldType === "integrarapimanager") {
          bo.set("camunda:integrarapimanager", "");
        }

        if (oldType === "gerarqrbarcode") {
          bo.set("camunda:gerarqrbarcode", "");
        }

        if (hasDmnSupport) {
          props = assign(props, DMN_CAPABLE_PROPS);
          if (newType === "dmn") {
            props["camunda:decisionRef"] = "";
          }
        }

        if (hasExternalSupport) {
          props = assign(props, EXTERNAL_CAPABLE_PROPS);
          if (newType === "external") {
            props["camunda:type"] = "external";
            props["camunda:topic"] = "";
          }
        }

        if (hasScriptSupport) {
          props["camunda:script"] = undefined;

          if (newType === "script") {
            props["camunda:script"] = elementHelper.createElement(
              "camunda:Script",
              {},
              bo,
              bpmnFactory,
            );
          }
        }

        if (hasBrmsSupport) {
          if (newType === "smartrules") {
            props["camunda:delegateExpression"] = "#{rulesDelegate}";
            props["camunda:asyncBefore"] = "true";
            props["camunda:smartrules"] = "true";
          }
        }

        if (hasRegistrarDocumentoSupport) {
          if (newType === "registrardocumento") {
            props["camunda:delegateExpression"] =
              "#{registrarDocumentoDelegate}";
            props["camunda:asyncBefore"] = "true";
            props["camunda:registrardocumento"] = "true";
          }
        }

        if (hasGerarMinutaSupport) {
          if (newType === "gerarminuta") {
            props["camunda:delegateExpression"] = "#{gerarMinutaDelegate}";
            props["camunda:asyncBefore"] = "true";
            props["camunda:gerarminuta"] = "true";
          }
        }

        if (hasGerarPdfRegistrarSupport) {
          if (newType === "gerarpdfregistrar") {
            props["camunda:delegateExpression"] =
              "#{generatePdfFromTemplateDelegate}";
            props["camunda:asyncBefore"] = "true";
            props["camunda:gerarpdfregistrar"] = "true";
          }
        }

        if (hasRegistrarArquivarDocumentoSupport) {
          if (newType === "registrararquivardocumento") {
            props["camunda:delegateExpression"] =
              "#{registrarDocumentoWithPathDelegate}";
            props["camunda:asyncBefore"] = "true";
            props["camunda:registrararquivardocumento"] = "true";
          }
        }

        if (hasGerarPdfNewSupport) {
          if (newType === "gerarpdfnew") {
            props["camunda:delegateExpression"] =
              "#{generatePdfFromTemplateWithPathDelegate}";
            props["camunda:asyncBefore"] = "true";
            props["camunda:gerarpdfnew"] = "true";
          }
        }

        if (hasGerarXmlSupport) {
          if (newType === "gerarxml") {
            props["camunda:delegateExpression"] =
              "#{generateXmlFromTemplateDelegate}";
            props["camunda:asyncBefore"] = "true";
            props["camunda:gerarxml"] = "true";
          }
        }

        if (hasIntegrarDoczSupport) {
          if (newType === "integrardocz") {
            props["camunda:delegateExpression"] = "#{doczDelegate}";
            props["camunda:asyncBefore"] = "true";
            props["camunda:integrardocz"] = "true";
          }
        }

        if (hasIntegrarDoczEtiquetaSupport) {
          if (newType === "integrardoczetiqueta") {
            props["camunda:delegateExpression"] = "#{doczEtiquetaDelegate}";
            props["camunda:asyncBefore"] = "true";
            props["camunda:integrardoczetiqueta"] = "true";
          }
        }

        if (hasIntegrarDoczSesiSupport) {
          if (newType === "integrardoczsesi") {
            props["camunda:delegateExpression"] =
              "#{sesiDoczDelegate}";
            props["camunda:asyncBefore"] = "true";
            props["camunda:integrardoczsesi"] = "true";
          }
        }

        if (hasIntegrarSeiSupport) {
          if (newType === "integrarsei") {
            props["camunda:delegateExpression"] = "#{seiDelegate}";
            props["camunda:asyncBefore"] = "true";
            props["camunda:integrarsei"] = "true";
          }
        }

        if (hasIntegrarAssinaturaSupport) {
          if (newType === "integrarassinatura") {
            props["camunda:delegateExpression"] = "#{signerDelegate}";
            props["camunda:asyncBefore"] = "true";
            props["camunda:integrarassinatura"] = "true";
          }
        }

        if (hasIntegrarAssinaturaLoteSupport) {
          if (newType === "integrarassinaturalote") {
            props["camunda:delegateExpression"] =
              "#{signerBatchDelegate}";
            props["camunda:asyncBefore"] = "true";
            props["camunda:integrarassinaturalote"] = "true";
          }
        }

        if (hasIntegrarAssinaturaLoteGetResultSupport) {
          if (newType === "integrarassinaturalotegetresult") {
            props["camunda:delegateExpression"] =
              "#{signerBatchGetResultDelegate}";
            props["camunda:asyncBefore"] = "true";
            props["camunda:integrarassinaturalotegetresult"] = "true";
          }
        }

        if (hasIntegrarApiManagerSupport) {
          if (newType === "integrarapimanager") {
            props["camunda:delegateExpression"] = "#{apiManagerDelegate}";
            props["camunda:asyncBefore"] = "true";
            props["camunda:integrarapimanager"] = "true";
          }
        }

        if (hasGerarQrBarCodeSupport) {
          if (newType === "gerarqrbarcode") {
            props["camunda:delegateExpression"] =
              "#{qrBarCodeDelegate}";
            props["camunda:asyncBefore"] = "true";
            props["camunda:gerarqrbarcode"] = "true";
          }
        }

        const commands = [];
        commands.push(cmdHelper.updateBusinessObject(element, bo, props));

        if (hasServiceTaskLikeSupport) {
          const connectors = extensionElementsHelper.getExtensionElements(
            bo,
            "camunda:Connector",
          );
          commands.push(
            map(connectors, function (connector) {
              return extensionElementsHelper.removeEntry(
                bo,
                element,
                connector,
              );
            }),
          );

          if (newType === "connector") {
            let extensionElements = bo.get("extensionElements");
            if (!extensionElements) {
              extensionElements = elementHelper.createElement(
                "bpmn:ExtensionElements",
                { values: [] },
                bo,
                bpmnFactory,
              );
              commands.push(
                cmdHelper.updateBusinessObject(element, bo, {
                  extensionElements,
                }),
              );
            }
            const connector = elementHelper.createElement(
              "camunda:Connector",
              {},
              extensionElements,
              bpmnFactory,
            );
            commands.push(
              cmdHelper.addAndRemoveElementsFromList(
                element,
                extensionElements,
                "values",
                "extensionElements",
                [connector],
                [],
              ),
            );
          }
        }

        return commands;
      },
    }),
  );

  return entries;
}
